import MDB from '../marketingdb';

const currentCulture = () => MDB.currentCulture();

export {
    currentCulture
};